<template>
  <div class="container mx-auto app-content-back">
    <div
      v-if="event"
      class="p-4"
    >
      <h1 class="text-4xl">
        {{ event.title }}
      </h1>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TeamEventParticipatePub',
    data () {
        return {
            eventId: '',
            event: null
        }
    },
    async mounted () {
        this.eventId = this.$route.params.id

        const response = await apiService.getPubEventByShareKey(this.eventId)

        this.event = response.data
    }
}

</script>

<style scoped>

</style>